import i18n from 'utils/i18n'
import type { AdminOffersFilterName } from 'utils/filters/admin'
import type { TableFiltersConfig } from 'components/Common/Table/Layout/Page/_methods/types'
import {
  filterTypes,
  CHECKBOX_LIST,
  DATE_INTERVAL,
  RADIO_LIST,
  SCORE,
  INTERVAL,
  PRICE_INTERVAL,
  SWITCHER,
  NUMBER,
  RHEOSTAT,
  offersFiltersTitle,
  offersFiltersName,
  offersFiltersKey,
  SEARCH_USERS,
  MULTISELECT_SWITCHER,
  RRP_INTERVAL,
  ADMIN_FILTERS_KEY,
  ADMIN_FILTERS_TITLE,
  ADMIN_FILTERS_NAME,
} from 'utils/consts'

// общая коллекция фильтров c их параметрами
export const getAdministrationFiltersCollection = () => [
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(offersFiltersTitle.periodOfValidityFilter),
    filterName:
      offersFiltersName.periodOfValidityFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().periodOfValidityFilter,
    maxDate: null,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.countryFilter),
    filterName: offersFiltersName.countryFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().countryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineRegionEUFilter),
    filterName:
      offersFiltersName.wineRegionEUFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().wineRegionEUFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.nationalGITypeFilter),
    filterName:
      offersFiltersName.nationalGITypeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().nationalGITypeFilter,
  },

  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.geoIndicationFilter),
    filterName:
      offersFiltersName.geoIndicationFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().geoIndicationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.specialClassificationFilter),
    filterName:
      offersFiltersName.specialClassificationFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().specialClassificationFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineTypeFilter),
    filterName:
      offersFiltersName.wineTypeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().wineTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.wineColourFilter),
    filterName:
      offersFiltersName.wineColourFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().wineColourFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.sweetnessTypeFilter),
    filterName:
      offersFiltersName.sweetnessTypeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().sweetnessTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.vintageFilter),
    filterName: offersFiltersName.vintageFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().vintageFilter,
  },
  {
    type: filterTypes[PRICE_INTERVAL],
    title: i18n.t(offersFiltersTitle.priceFilter),
    filterName: offersFiltersName.priceFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().priceFilter,
  },
  {
    type: filterTypes[RRP_INTERVAL],
    title: i18n.t(offersFiltersTitle.retailPriceFilter),
    filterName:
      offersFiltersName.retailPriceFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().retailPriceFilter,
  },
  {
    type: filterTypes[RHEOSTAT],
    title: i18n.t(offersFiltersTitle.priceCoefFilter),
    filterName:
      offersFiltersName.priceCoefFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().priceCoefFilter,
  },
  {
    type: filterTypes[MULTISELECT_SWITCHER],
    title: i18n.t(offersFiltersTitle.grapesFilter),
    filterName: offersFiltersName.grapesFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().grapesFilter,
    switchType: filterTypes[SWITCHER],
    switchFilterName: offersFiltersName.monocepageFilter,
    switchTitle: i18n.t(offersFiltersTitle.monocepageFilter),
    switchApiFilterName: offersFiltersKey().monocepageFilter,
  },
  {
    type: filterTypes[INTERVAL],
    title: i18n.t(offersFiltersTitle.alcoholLevelFilter),
    filterName:
      offersFiltersName.alcoholLevelFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().alcoholLevelFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.certificatesFilter),
    filterName:
      offersFiltersName.certificatesFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().certificatesFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.bottleSizeFilter),
    filterName:
      offersFiltersName.bottleSizeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().bottleSizeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.packageTypeFilter),
    filterName:
      offersFiltersName.packageTypeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().packageTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.distributionFilter),
    filterName:
      offersFiltersName.distributionFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().distributionFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.deliveryTermsFilter),
    filterName:
      offersFiltersName.deliveryTermsFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().deliveryTermsFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.countryOfShipmentFilter),
    filterName:
      offersFiltersName.countryOfShipmentFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().countryOfShipmentFilter,
  },
  {
    type: filterTypes[NUMBER],
    title: i18n.t(offersFiltersTitle.minimalBatchFilter),
    filterName: offersFiltersName.minimalBatchFilter,
    apiFilterName: offersFiltersKey().minimalBatchFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.producerFilter),
    filterName:
      offersFiltersName.producerFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().producerFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.brandFilter),
    filterName: offersFiltersName.brandFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().brandFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyUsernameFilter),
    filterName:
      offersFiltersName.buyerCompanyUsernameFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyUsernameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyCategoryFilter),
    filterName:
      offersFiltersName.buyerCompanyCategoryFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyCategoryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.buyerCompanyCountryFilter),
    filterName:
      offersFiltersName.buyerCompanyCountryFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().buyerCompanyCountryFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.sellerCompanyUsernameFilter),
    filterName:
      offersFiltersName.sellerCompanyUsernameFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().sellerCompanyUsernameFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.sellerCompanyCategoryFilter),
    filterName:
      offersFiltersName.sellerCompanyCategoryFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().sellerCompanyCategoryFilter,
  },
  {
    type: filterTypes[SCORE],
    title: i18n.t(offersFiltersTitle.wwlRatingFilter),
    filterName:
      offersFiltersName.wwlRatingFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().wwlRatingFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(offersFiltersTitle.exhibitionFilter),
    filterName:
      offersFiltersName.exhibitionFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().exhibitionFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(offersFiltersTitle.exclusiveOffersFilter),
    filterName: offersFiltersName.exclusiveOffersFilter,
    apiFilterName: offersFiltersKey().exclusiveOffersFilter,
  },
  {
    type: filterTypes[SWITCHER],
    title: i18n.t(offersFiltersTitle.onlyFromProducerFilter),
    filterName: offersFiltersName.onlyFromProducerFilter,
    apiFilterName: offersFiltersKey().onlyFromProducerFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(offersFiltersTitle.wineOfferTypeFilter),
    filterName:
      offersFiltersName.wineOfferTypeFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().wineOfferTypeFilter,
  },
  {
    type: filterTypes[CHECKBOX_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.statusFilter),
    filterName: ADMIN_FILTERS_NAME.statusFilter satisfies AdminOffersFilterName,
    apiFilterName: offersFiltersKey().statusFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.packshotFilter),
    filterName:
      ADMIN_FILTERS_NAME.packshotFilter satisfies AdminOffersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.packshotFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.frontLabelFilter),
    filterName:
      ADMIN_FILTERS_NAME.frontLabelFilter satisfies AdminOffersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.frontLabelFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.backLabelFilter),
    filterName:
      ADMIN_FILTERS_NAME.backLabelFilter satisfies AdminOffersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.backLabelFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(offersFiltersTitle.firstPublishedAtFilter),
    filterName: offersFiltersName.firstPublishedAtFilter,
    apiFilterName: offersFiltersKey().firstPublishedAtFilter,
  },
  {
    type: filterTypes[DATE_INTERVAL],
    title: i18n.t(offersFiltersTitle.updatedAtFilter),
    filterName: offersFiltersName.updatedAtFilter,
    apiFilterName: offersFiltersKey().updatedAtFilter,
  },
  {
    type: filterTypes[SEARCH_USERS],
    title: i18n.t(ADMIN_FILTERS_TITLE.creationUserFilter),
    filterName:
      ADMIN_FILTERS_NAME.authorUserFilter satisfies AdminOffersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.authorUserFilter,
  },
  {
    type: filterTypes[RADIO_LIST],
    title: i18n.t(ADMIN_FILTERS_TITLE.hasImagesFilter),
    filterName:
      ADMIN_FILTERS_NAME.hasImagesFilter satisfies AdminOffersFilterName,
    apiFilterName: ADMIN_FILTERS_KEY.hasImagesFilter,
  },
]

export const adminOffersFiltersConfig: TableFiltersConfig = {
  getFiltersCollection: getAdministrationFiltersCollection,
  pathToStore: ['offers'],
  filtersDataPath: ['admin', 'wineOffers', 'wineOffersFilters'],
  showResultsTextKey: 'filters.button.showOffers',
}
